<template>
    <div id="banner">
        <template v-if="banner && banner.bannerType === 'PHOTO'">
            <template v-if="banner.bannerPhotoList.length>1">
                <n-carousel class="my-swipe" :style="[width > 0 ? {width: width + 'px'} : {}, height > 0 ? {height: height + 'px'} : {height:carouselH + 'px'}]" ref="splide" draggable autoplay :loop="true">
                    <template v-for="item in banner.bannerPhotoList" :key="item">
                        <img :src="`${item.photoUrl}`" class="bannerImg" :style="[height > 0 ? { height: height + 'px' } : { height: carouselH + 'px' }, contain ? { objectFit: 'contain' } : {}]"/>
                    </template>
                </n-carousel>
            </template>
            <img v-if="banner.bannerPhotoList.length==1" :src="`${banner.bannerPhotoList[0].photoUrl}`" class="bannerImg" :style="[width > 0 ? { width: width + 'px' } : {}, height > 0 ? { height: height + 'px' } : { height: carouselH + 'px' }, contain ? {objectFit: 'contain'} : {}]"/>
        </template>
        <template v-if="banner && banner.bannerType === 'VIDEO'">
            <div class="videoWrapper" :style="[width > 0 ? {width: width + 'px'} : {}, height > 0 ? {height: height + 'px'} : {}]">
                <video ref="videoRef" class="video" :style="(albumStore.screenWidth > 1200 && controls) ?'object-fit: contain':'object-fit: cover'" :src="banner.bannerVideo.videoUrl" :poster="banner.bannerVideo.coverUrl" :controls="controls" />
                <img v-if="!controls" :src="`${config.EVN.imageUrl}play.png`" @click="play" class="play" />
            </div>
        </template>
    </div>
</template>
<script lang="ts">
import {onMounted, defineComponent, PropType, ref, watchEffect, nextTick} from 'vue'
import {Swipe, SwipeItem} from 'vant'
import type {BrandBannerType} from '@/views/props'
import {NCarousel} from 'naive-ui'
import config from '@/config'
import {useAlbumStore} from '@/store/album'

interface BannerItem {
    width: number
    height: number
    photoId: number
    photoUrl: string
}

interface Banner {
    bannerType: BrandBannerType
    bannerPhotoList: BannerItem[]
    bannerLive: {coverUrl: string; contentUrl: string}
    bannerVideo: {coverUrl: string; contentUrl?: string; videoUrl?: string}
}

export default defineComponent({
    components: {
        Swipe,
        SwipeItem,
        NCarousel
    },
    props: {
        banner: {
            type: Object as PropType<Banner>,
            default: () => {}
        },
        width: {
            type: Number,
            default: 0
        },
        height: {
            type: Number,
            default: 0
        },
        contain: {
            type: Boolean,
            default: false
        }
    },

    setup(props) {
        const albumStore = useAlbumStore()
        const videoRef = ref()
        const controls = ref(false)
        const carouselH = ref(0)
        const play = () => {
            videoRef.value.fullScreen = true
            controls.value = true
            videoRef.value.play()
        }
        watchEffect(() => {
  
        })
        
        onMounted(() => {
            if (props.banner && props.banner.bannerType == 'PHOTO') {
                let url = props.banner.bannerPhotoList[0].photoUrl;
                const img = new Image()
                  img.onload = async () => {
                      let { width, height } = img
                      await nextTick()
                      const Ele = document.querySelector('#banner')
                      if (Ele) {
                          carouselH.value = (Ele.clientWidth * height) / width
                      }
                        // console.log('ele==>',Ele.clientWidth)
                }
                img.src = url
            }
        })

        const isWifi = () => {
            try {
                let wifi = true
                let ua = window.navigator.userAgent
                let con = window.navigator.connection
                // 如果是微信
                if (/MicroMessenger/.test(ua)) {
                    if (ua.indexOf('WIFI') >= 0) {
                        return true
                    } else {
                        wifi = false
                    }
                    // 如果支持navigator.connection
                } else if (con) {
                    let network = con.effectiveType
                    if (network !== 'wifi' && network !== '2' && network !== 'unknown') {
                        wifi = false
                    }
                }
                return wifi
            } catch (e) {
                return false
            }
        }

        return {
            play,
            config,
            videoRef,
            controls,
            albumStore,
            carouselH
        }
    }
})
</script>

<style scoped>
::v-deep .n-carousel__slide{
    display: flex;
}
.bannerImg {
    object-fit: cover;
    width: 100%;
    height: auto;
    display: block;
}

.my-swipe {
    width: 100%;
    /* background-color: #E5E5E5; */
}

.videoWrapper {
    height: 56.25vw;
    width: 100%;
    position: relative;
}

.video {
    height: 100%;
    width: 100%;
}

.play {
    width: 50px;
    height: 50px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
</style>
